import React from "react";
import "./SolutionsServices.css";
import Button from "../../components/Button/Button";
import { Container, Row, Col, Card, Carousel } from "react-bootstrap";
import solutions_img_2 from "../../assets/images/solutions_img_2.png";
import OfferingsTabs from "../../components/OfferingsTabs/OfferingsTabs";
import "bootstrap/dist/css/bootstrap.min.css";
import { solution_services_caseStudies } from "../../StaticData/caseStudiesData";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import { FaArrowUp, FaArrowRight } from "react-icons/fa";
import { Helmet } from "react-helmet";
import long_arrow from "../../assets/images/long_arrow.svg";

const SolutionsServices = () => {
  return (
    <div className="SolutionsServices-page">
         <Helmet>
        <title>IT Solutions and Services | Idexcel</title>
        <meta
          name="description"
          content="Discover innovative IT solutions and services designed to enhance efficiency, security, and scalability. Empower your business with cutting-edge technology—get started today!"
        />
      </Helmet>
      {/* //banner section  */}
      <section className="banner-section mb-5">
        <Container className="mt-5">
          <Row>
            <Col lg={12}>
              <div className="banner-overlay mt-5">
                <h1 className="banner-title mb-5">
                  Seamless Enterprise Evolution with<br></br>
                  AI and Cloud
                </h1>
                <Button className="banner-button" size="large" color="banner">
                  <a href="/contact-us" className="text-white">
                    Contact Us
                  </a>
                  <FaArrowUp className="explore-arrow" />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* section 2 */}
      <Container>
        <section
          className="image-text-section py-5"
          style={{ backgroundColor: "#EDF3FF" }}
        >
          <Row className="custom-flex align-items-center justify-content-around">
            {/* left Side: Content */}
            <Col lg={6} md={6} sm={12} className="content-box">
              <h1 className="section-title">
                How to Lead in <br></br>Technological Evolution?
              </h1>
              <p className="section-text">
                Leverage AI-driven automation, cloud-native architectures, and
                intelligent data ecosystems. Enable seamless integration,
                predictive analytics, and adaptive security to set new industry
                benchmarks and drive future-ready growth.
              </p>
            </Col>

            {/* right Side: Image */}
            <Col lg={5} md={6} sm={12} className="image-box ">
              <img
                src={solutions_img_2}
                alt="Tech Image"
                className="img-fluid"
              />
            </Col>
          </Row>
        </section>
      </Container>

      <OfferingsTabs />

      {/* section 2 */}
      <section className="next-section-3 mt-5" style={{ backgroundColor: "#F1F8FF" }}>
        {/* <Container fluid> */}
        <Container className="section-3">
          <h1 className="text-center mb-4 pt-0 section-title">
            Customer Success Stories
          </h1>
          <Carousel>
            {solution_services_caseStudies.map((study, index) => (
              <Carousel.Item key={study.id}>
                <div className="d-flex align-items-center flex-column flex-xl-row flex-md-row h-100" style={{gap:"45px"}}>
                  {/* Image on the left side */}
                  <div className="carousel-image " style={{ flex: 1, display: "flex", justifyContent: "end" }}>
                    <img
                      className="d-block zoom-on-hover"
                      src={study.image}
                      alt={study.title}
                      style={{ height: "350px", objectFit: "cover" }}
                    />
                  </div>
                  {/* Title and Description on the right side */}
                  <div
                    className="carousel-text ml-3 col-12 col-md-8"
                    style={{ flex: 1}}
                  >
                    <h3>{study.title}</h3>
                    <p>{study.description}</p>
                    <a href={study.link} target="_blank" className="arrow-container">
                      <img src={long_arrow} alt="Arrow" />
                    </a>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </section>

      <GetInTouch heading="Modernize. Scale. Stay Ahead." />
    </div>
  );
};

export default SolutionsServices;
